'use client';

import { useSearchParams } from 'next/navigation';
import BreadcrumbContainer from '@//containers/BreadcrumbContainer';
import useSearchSubscription from '@//data/subscriptions/search/useSearchSubscription';
import type { ElasticSearchResponseFacet } from '@//ElasticSearch';

interface SearchBreadcrumbProps {
  facets: ElasticSearchResponseFacet[];
}

const SearchBreadcrumb = ({ facets }: SearchBreadcrumbProps) => {
  const searchParams = useSearchParams();
  const searchSubscriptionId = searchParams.get('searchSubscriptionId') ?? undefined;
  const searchSubscriptionQuery = useSearchSubscription(searchSubscriptionId);
  const searchSubscription = searchSubscriptionQuery.data?.response;

  return <BreadcrumbContainer facets={facets} searchSubscriptionName={searchSubscription?.name} />;
};

export default SearchBreadcrumb;
